// extracted by mini-css-extract-plugin
export default {"segmentColorPicker":"segment-color-picker__lxyO3zlD","tabBar":"tab-bar__zdJPCnsp","line":"line__lxiK09SZ","checkbox":"checkbox__dhaeG8aL","afterTheme":"after-theme__lN6N0SzZ"};